import React, { useRef, useEffect, useCallback, useState} from 'react';

export const useGroupPos = ({container, group, track, trackSteps, scale=1}) => {
    if (scale === 0) {
        scale = 1;
    }
    let [pos, setPos] = useState(undefined);
    let counter = useRef(0);

    useEffect(() => {
        if (!container.current) {
            return;
        }
        let _counter = ++counter.current;
        setTimeout(() => {
            if (_counter !== counter.current) {
                return;
            }
            // get the positions for every step and find the min and max
            let rects = [];
            for (let step of group.steps) {
                let el = document.getElementById("stepdata-" + step.id);
                if (!el) {
                    continue;
                }
                let rect = el.getBoundingClientRect();
                rects.push(rect);
            }

            // get min/max
            let minLeft = Math.min(... rects.map(x => x.left));
            let maxLeft = Math.max(... rects.map(x => x.left));
            let minTop = Math.min(... rects.map(x => x.top));
            let maxTop = Math.max(... rects.map(x => x.top));

            if (!container.current) {
                return;
            }
            let bounding = container.current.getBoundingClientRect();
            let pos = {
                x: (1.0/scale) * (minLeft - bounding.left - 4),
                y: (1.0/scale) * (minTop - bounding.top + 3),
                height: maxTop - minTop + 18,
                width: maxLeft - minLeft + 30
            };
            setPos(pos);
        }, 75);
    }, [setPos, group, track, trackSteps]);


    return {pos};
};
